// JobSheet — the phone's bottom sheet for one job (Month/Week/Jobs lists and the
// 390 board). Facts on one card, then "Open customer" (the customer window on its
// Appointments tab). Nothing here writes.
import React, { lazy, Suspense, useState } from "react";
import Sheet from "../../ui/Sheet";
import Button from "../../ui/button";
import { formatCurrency } from "../dispatch/utils";
import { dayLabel } from "./useRangeBoard";

const CustomerPopup = lazy(() => import("../../Profile/CustomerPopup"));

export default function JobSheet({ job, onClose, vocab = {} }) {
  const [open, setOpen] = useState(false);
  if (!job) return null;
  const time = job.computedStart || "";
  const rows = [
    ["When", `${job.serviceDay ? dayLabel(job.serviceDay) : ""}${time ? ` · ${time}` : ""}${job.computedEnd ? `–${job.computedEnd}` : ""}`],
    [vocab.worker ? vocab.worker.charAt(0).toUpperCase() + vocab.worker.slice(1) : "Tech", job.technicianName || vocab.unassigned || "Unassigned"],
    [vocab.service ? vocab.service.charAt(0).toUpperCase() + vocab.service.slice(1) : "Service", `${job.serviceName || job.serviceCode || "—"}${job.serviceCode && job.serviceName ? ` (${job.serviceCode})` : ""}`],
    ["Duration", job.durationMinutes ? `${job.durationMinutes} min` : "—"],
    ["Status", job.status || "scheduled"],
    ["Value", job.value ? formatCurrency(job.value) : "—"],
    ["Address", job.address || "—"],
  ];
  return (
    <>
      <Sheet
        open={Boolean(job) && !open}
        onClose={onClose}
        title={job.customerName || "Job"}
        footer={job.customerId ? <Button variant="primary" onClick={() => setOpen(true)}>Open customer</Button> : null}
      >
        <dl className="sc-facts">
          {rows.map(([k, v]) => (<React.Fragment key={k}><dt>{k}</dt><dd>{v}</dd></React.Fragment>))}
          {job.notes ? <><dt>Notes</dt><dd className="sc-facts-notes">{job.notes}</dd></> : null}
        </dl>
      </Sheet>
      {open ? (
        <Suspense fallback={null}>
          <CustomerPopup
            lead={{ object: "customer", id: job.customerId, customer_id: job.customerId, display_name: job.customerName }}
            leadType="customer"
            initialTab="appointments"
            focusAppointment={job.crmAppointmentId || job.id}
            boardStartLabel={time || null}
            onClose={() => { setOpen(false); onClose?.(); }}
          />
        </Suspense>
      ) : null}
    </>
  );
}
